





































































import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import { AccountRelationshipSearchResource, RelationshipSearchResult } from '@/api/relationshipsearch';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import SpecificConsumerAccountDetails from '@/components/account/SpecificConsumerAccountDetails.vue';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    SpecificConsumerAccountDetails,
  },
})
export default class ConsumerAccountDetails extends Vue {
  fiId!: string;

  customerId: string = '';

  headerItems: any = [{
    text: 'Rewards Processing',
    disabled: false,
    link: false,
  },
  {
    text: 'Consumer/Account Details',
    disabled: true,
  }];

  headers: any = [
    { text: 'AccountNumber', value: 'coreAccountNumber', width: '200px' },
    { text: 'Name', value: 'customerName', width: '200px' },
    { text: 'Relationship', value: 'relationshipClassification', width: '200px' },
    { text: 'Action', value: 'action' },
  ]

  footerProps: any = {
    'items-per-page-options': [{ value: -1, text: 'All' }, 25, 50, 100],
  }

  searchString: string = '';

  searchResults: RelationshipSearchResult[] = [];

  loading: boolean = false;

  searching: boolean = false;

  @Inject('AccountRelationshipSearchResource')
  searchService!: AccountRelationshipSearchResource;

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange(newVal: any) {
    this.customerId = this.$route.params.customerId;
  }

  @Watch('fiId')
  onFiChange() {
    this.searchResults = [];
    this.customerId = '';
  }


  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  searchAccountNumber() {
    if (this.customerId) {
      this.$router.push({ name: 'consumeraccountsearch', params: { clientId: this.$route.params.clientId } });
    }

    this.customerId = '';
    this.searchResults = [];
    this.searching = true;

    this.searchService.searchByAccountNumber(this.fiId, this.searchString, 100)
      .then((result: RelationshipSearchResult[]) => {
        this.searchResults = result;
      }).catch((error: any) => {
        this.handleSearchError(error);
      }).finally(() => {
        this.searching = false;
      });
  }

  searchName() {
    if (this.customerId) {
      this.$router.push({ name: 'consumeraccountsearch', params: { clientId: this.$route.params.clientId } });
    }

    this.customerId = '';
    this.searchResults = [];
    this.searching = true;

    this.searchService.searchByName(this.fiId, this.searchString, 1000, 100).then(
      (result: RelationshipSearchResult[]) => {
        this.searchResults = result;
      },
    ).catch((error: any) => {
      this.handleSearchError(error);
    }).finally(() => {
      this.searching = false;
    });
  }

  handleSearchError(error: any) {
    if (error.response.status !== 401) {
      if (error.response.status === 504) {
        this.showErrorMessage('The search timed out.');
      } else {
        this.showErrorMessage('An unexpected error occurred while attempting to perform the search.');
      }
    }
  }
}
